import React, { useEffect, useState } from 'react';
import './previous-attempts-modal.styles.scss';
import Modal from '@/components/SHARED/modal/modal.component';
import EvalReflectionBox from '../eval-reflection-box/eval-reflection-box.component';
import { format } from 'date-fns';
import { getUploadUrlFromPath } from '@/utils/getUrlFromFbPath';
import EvidenceButton from '@/components/evidence-button/evidence-button.component';

const PreviousAttemptsModal = ({
  show,
  cancel,
  previousAttempts, //array of previous attempt objects
  allDetails, //object of all MC details with detailId keys
  previousComments //object of previous comments with timestamp keys
}) => {

  const [display, setDisplay] = useState(null);
  const [attemptsToDisplay, setAttemptsToDisplay] = useState([]);

  useEffect(() => {
    if (!show || !previousAttempts) return;
    console.log(previousComments);
    formatAttempts();
  }, [show, previousAttempts, previousComments])

  // useEffect(() => {
  //   console.log(allDetails);
  // }, [allDetails])

  async function goToEvidenceFile(link) {
    const url = await getUploadUrlFromPath(link);
    window.open(url, '_new');
  }

  function formatAttempts() {
    const newArr = [];
    const sortedComments = Object.values(previousComments)
      .sort((a, b) => a.timestamp > b.timestamp ? 1 : -1)
    const sortedAttempts = previousAttempts
      .sort((a, b) => a.timestamp > b.timestamp ? 1 : -1);
    for (let i = 0; i < sortedAttempts.length; i++) {
      const attempt = sortedAttempts[i];
      if (!attempt.comment) {
        const comment = sortedComments[i] || null;
        attempt.comment = comment;
      }
      newArr.push(attempt);
    }
    setAttemptsToDisplay(newArr);
  }


  return (
    <div className='previous-attempts-modal'>
      <Modal show={show} cancel={cancel} cls='wide' closeButton={true} text="View Previous Attempts" >
        <div className='attempts-list'>
          {
            (attemptsToDisplay.length > 0) &&
            attemptsToDisplay
              .sort((a, b) => a.timestamp < b.timestamp ? 1 : -1)
              .map((a, index) => (
                <div 
                  key={a.timestamp + a.id + index}
                  className='attempt-content'>
                  <div className='date'>{format(new Date(a.timestamp), 'Pp')}</div>
                  {
                    (a.exp) &&
                    a.exp.map((b, index) => (
                      (b) &&
                      <div key={b + new Date().getTime()}>
                        <EvalReflectionBox
                          data={{
                            'exp': b,
                            'upload': a.upload[index],
                            'detailId': a.detailId
                          }}
                          onClick={() => goToEvidenceFile(a.upload[index].link)}
                          allDetails={allDetails}
                        />
                      </div>
                    ))
                  }
                  {
                    (a.file) &&
                    <div>
                      <EvidenceButton
                        evidenceData={a}
                        onClick={() => goToEvidenceFile(a.file)} />
                    </div>
                  }
                  {
                    (a.comment) &&
                    <div className='evaluator-comment'>
                      <div className='evaluator-comment-box g-list-item'>
                        <b>Evaluator Comment:</b>
                        <div className="g-space-0-5"></div>
                        <div className='meta'>{format(new Date(a.comment.timestamp), 'Pp')}</div>
                        <div className='comment-text'>{a.comment.comment}</div>
                      </div>
                    </div>
                  }
                  {
                    (previousAttempts.length > 1 && index !== previousAttempts.length - 1) &&
                    <hr />
                  }
                </div>
              ))
          }
        </div>
      </Modal>
    </div>
  )
}

export default PreviousAttemptsModal